import * as React from "react";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

// internal
import { styles } from "./CalendarCurrentTimeMarker.styles";

// util
import { ZonedMoment } from "@clockwise/client-commons/src/util/time-zone";

export interface CalendarCurrentTimeMarkerProps extends WithStyles<typeof styles> {
  day: ZonedMoment;
}

export interface CalendarCurrentTimeMarkerState {
  showMarker: boolean;
  markerTop: string;
}

class CalendarCurrentTimeMarkerComponent extends React.Component<
  CalendarCurrentTimeMarkerProps,
  CalendarCurrentTimeMarkerState
> {
  private minuteInterval?: ReturnType<typeof setTimeout>;
  private expectedStepTime: ZonedMoment;

  constructor(props: CalendarCurrentTimeMarkerProps) {
    super(props);

    this.state = {
      showMarker: false,
      markerTop: "0%",
    };
  }

  private updateState = (now: ZonedMoment) => {
    const showMarker = now.isSame(this.props.day, "days");
    const markerTop = showMarker ? `${(100 * (now.hours() + now.minutes() / 60)) / 24}%` : "0%";

    this.setState({
      showMarker,
      markerTop,
    });
  };

  private onMinuteChange = () => {
    const now = new ZonedMoment();
    let dt = now.valueOf() - this.expectedStepTime.valueOf();

    if (dt > 60000) {
      dt = dt % 60000;
    }

    this.updateState(now);

    this.minuteInterval = setTimeout(() => this.onMinuteChange(), 60000 - dt);
  };

  public UNSAFE_componentWillMount() {
    const now = new ZonedMoment();
    const driftTime = 60000 - now.seconds() * 1000 + now.milliseconds();
    this.expectedStepTime = now.add(driftTime, "milliseconds");

    this.minuteInterval = setTimeout(() => this.onMinuteChange(), driftTime);

    this.updateState(now);
  }

  public componentWillUnmount() {
    if (this.minuteInterval) {
      clearInterval(this.minuteInterval);
      delete this.minuteInterval;
    }
  }

  public render() {
    return this.state.showMarker ? (
      <React.Fragment>
        <div style={{ top: this.state.markerTop }} className={this.props.classes.markerCircle} />
        <div style={{ top: this.state.markerTop }} className={this.props.classes.marker} />
      </React.Fragment>
    ) : null;
  }
}

export const CalendarCurrentTimeMarker = withStyles(styles)(CalendarCurrentTimeMarkerComponent);
